import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gw-hamburger-icon',
  templateUrl: './hamburger-icon.component.html',
  styleUrls: ['./hamburger-icon.component.scss']
})
export class HamburgerIconComponent implements OnInit {
  @Input() opened: boolean;

  constructor() { }

  ngOnInit() {
  }

}
